import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["title", "href"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = ["title", "href"]
const _hoisted_5 = { key: 2 }
const _hoisted_6 = ["title", "href", "data-job-id"]
const _hoisted_7 = { key: 3 }
const _hoisted_8 = ["title", "href"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["title", "href"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = ["title", "href"]
const _hoisted_13 = { key: 5 }
const _hoisted_14 = ["title", "href"]
const _hoisted_15 = { key: 6 }
const _hoisted_16 = ["title", "href"]
const _hoisted_17 = ["href"]
const _hoisted_18 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_btn = _resolveComponent("btn")!
  const _component_job_scm_actions = _resolveComponent("job-scm-actions")!
  const _component_ui_socket = _resolveComponent("ui-socket")!
  const _component_dropdown = _resolveComponent("dropdown")!

  return (_ctx.authz)
    ? (_openBlock(), _createBlock(_component_dropdown, {
        key: 0,
        class: _normalizeClass(["btn-group", { 'pull-right': _ctx.pullRight, 'visibility-hidden': _ctx.showOnHover }]),
        "menu-right": _ctx.pullRight,
        "append-to-body": ""
      }, {
        dropdown: _withCtx(() => [
          (_ctx.authz['update'])
            ? (_openBlock(), _createElementBlock("li", _hoisted_1, [
                _createElementVNode("a", {
                  title: _ctx.$t('scheduledExecution.action.edit.button.tooltip'),
                  href: _ctx.editHref
                }, [
                  _cache[6] || (_cache[6] = _createElementVNode("i", { class: "glyphicon glyphicon-edit" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("scheduledExecution.action.edit.button.label")), 1)
                ], 8, _hoisted_2)
              ]))
            : _createCommentVNode("", true),
          (_ctx.authz['read'] && _ctx.authz['create'] && _ctx.authProjJobCreate)
            ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
                _createElementVNode("a", {
                  title: _ctx.$t('scheduledExecution.action.duplicate.button.tooltip'),
                  href: _ctx.duplicateHref
                }, [
                  _cache[7] || (_cache[7] = _createElementVNode("i", { class: "glyphicon glyphicon-plus" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("scheduledExecution.action.duplicate.button.label")), 1)
                ], 8, _hoisted_4)
              ]))
            : _createCommentVNode("", true),
          (_ctx.authz['read'])
            ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
                _createElementVNode("a", {
                  title: _ctx.$t('scheduledExecution.action.duplicate.button.tooltip'),
                  href: _ctx.duplicateOtherHref,
                  "data-action": "copy_other_project",
                  "data-job-id": _ctx.job.id,
                  class: "page_action"
                }, [
                  _cache[8] || (_cache[8] = _createElementVNode("i", { class: "glyphicon glyphicon-plus" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("scheduledExecution.action.duplicate.other.button.label")), 1)
                ], 8, _hoisted_6)
              ]))
            : _createCommentVNode("", true),
          _cache[19] || (_cache[19] = _createElementVNode("li", { class: "divider" }, null, -1)),
          (_ctx.authz['delete'] && _ctx.authProjJobDelete)
            ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                _createElementVNode("a", {
                  title: _ctx.$t('delete.this.job'),
                  href: _ctx.deleteHref,
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.action('delete')), ["prevent"]))
                }, [
                  _cache[9] || (_cache[9] = _createElementVNode("b", { class: "glyphicon glyphicon-remove-circle" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("scheduledExecution.action.delete.button.label")), 1)
                ], 8, _hoisted_8)
              ]))
            : _createCommentVNode("", true),
          (
          (_ctx.jobScheduled && _ctx.authz['toggle_schedule']) ||
          _ctx.authz['toggle_execution']
        )
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                _cache[12] || (_cache[12] = _createElementVNode("li", { class: "divider" }, null, -1)),
                (_ctx.jobScheduled && _ctx.authz['toggle_schedule'] && !_ctx.jobScheduleEnabled)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                      _createElementVNode("a", {
                        title: _ctx.$t('enable.schedule.this.job'),
                        class: "page_action",
                        "data-action": "enable_job_schedule_single",
                        href: _ctx.enableScheduleHref,
                        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.action('enable_schedule')), ["prevent"]))
                      }, [
                        _cache[10] || (_cache[10] = _createElementVNode("b", { class: "glyphicon glyphicon-check" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("scheduledExecution.action.enable.schedule.button.label")), 1)
                      ], 8, _hoisted_10)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.jobScheduled && _ctx.authz['toggle_schedule'] && _ctx.jobScheduleEnabled)
                  ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                      _createElementVNode("a", {
                        title: _ctx.$t('disable.schedule.this.job'),
                        class: "page_action",
                        "data-action": "disable_job_schedule_single",
                        href: _ctx.disableScheduleHref,
                        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.action('disable_schedule')), ["prevent"]))
                      }, [
                        _cache[11] || (_cache[11] = _createElementVNode("b", { class: "glyphicon glyphicon-unchecked" }, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("scheduledExecution.action.disable.schedule.button.label")), 1)
                      ], 8, _hoisted_12)
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.authz['toggle_execution'] && !_ctx.jobExecutionEnabled)
            ? (_openBlock(), _createElementBlock("li", _hoisted_13, [
                _createElementVNode("a", {
                  title: _ctx.$t('enable.execution.this.job'),
                  class: "page_action",
                  "data-action": "enable_job_execution_single",
                  href: _ctx.enableExecutionHref,
                  onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.action('enable_execution')), ["prevent"]))
                }, [
                  _cache[13] || (_cache[13] = _createElementVNode("b", { class: "glyphicon glyphicon-check" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("scheduledExecution.action.enable.execution.button.label")), 1)
                ], 8, _hoisted_14)
              ]))
            : _createCommentVNode("", true),
          (_ctx.authz['toggle_execution'] && _ctx.jobExecutionEnabled)
            ? (_openBlock(), _createElementBlock("li", _hoisted_15, [
                _createElementVNode("a", {
                  title: _ctx.$t('disable.execution.this.job'),
                  class: "page_action",
                  "data-action": "disable_job_execution_single",
                  href: _ctx.disableExecutionHref,
                  onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.action('disable_execution')), ["prevent"]))
                }, [
                  _cache[14] || (_cache[14] = _createElementVNode("b", { class: "glyphicon glyphicon-unchecked" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("scheduledExecution.action.disable.execution.button.label")), 1)
                ], 8, _hoisted_16)
              ]))
            : _createCommentVNode("", true),
          (_ctx.authz['read'])
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                _cache[16] || (_cache[16] = _createElementVNode("li", { class: "divider" }, null, -1)),
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['xml', 'yaml', 'json'], (format) => {
                  return _createElementVNode("li", { key: format }, [
                    _createElementVNode("a", {
                      href: _ctx.downloadFormatHref(format)
                    }, [
                      _cache[15] || (_cache[15] = _createElementVNode("b", { class: "glyphicon glyphicon-file" }, null, -1)),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("scheduledExecution.action.downloadformat.button.label", [
                format.toUpperCase(),
              ])), 1)
                    ], 8, _hoisted_17)
                  ])
                }), 64))
              ], 64))
            : _createCommentVNode("", true),
          (_ctx.authProjEventRead && _ctx.authz['read'])
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 8 }, [
                _cache[18] || (_cache[18] = _createElementVNode("li", { class: "divider" }, null, -1)),
                _createElementVNode("li", null, [
                  _createElementVNode("a", {
                    href: _ctx.activityPageHref()
                  }, [
                    _cache[17] || (_cache[17] = _createElementVNode("b", { class: "fas fa-history" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t("scheduledExecution.action.activity.button.label")), 1)
                  ], 8, _hoisted_18)
                ])
              ], 64))
            : _createCommentVNode("", true),
          _createVNode(_component_job_scm_actions, { job: _ctx.job }, null, 8, ["job"]),
          _createVNode(_component_ui_socket, {
            location: "job-actions-menu",
            section: "extended",
            "socket-data": { job: _ctx.job }
          }, null, 8, ["socket-data"])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_btn, {
            size: "xs",
            class: "dropdown-toggle",
            "data-job-id": _ctx.job.id
          }, {
            default: _withCtx(() => [
              (_ctx.showButtonTitle)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createTextVNode(_toDisplayString(_ctx.$t("actions")), 1)
                  ], 64))
                : _createCommentVNode("", true),
              _cache[5] || (_cache[5] = _createElementVNode("span", { class: "caret" }, null, -1))
            ]),
            _: 1
          }, 8, ["data-job-id"])
        ]),
        _: 1
      }, 8, ["class", "menu-right"]))
    : _createCommentVNode("", true)
}